// extracted by mini-css-extract-plugin
export default {"blockwrapper":"GQ","header":"HQ","name":"IQ","columns":"JQ","imagewrapper":"KQ","addinfo":"LQ","description":"MQ","price":"NQ","old":"OQ","new":"PQ","desc_d":"QQ","infoblock":"RQ","desc_m":"SQ"};
    if(module.hot) {
      // 1714422956884
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  